import * as actionTypes from '../actions/actionTypes';

const initialState = {
    canNavigate: true,
};

const navigation = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.navigation.SET_CAN_NAVIGATE:
            return {
                ...state,
                canNavigate: action.canNavigate,
            };
        default:
            return state;
    }
};

export default navigation;
